import { EditOutlined } from "@mui/icons-material";
import React, { useCallback, useMemo, useState } from "react";
import { columnTypesDate } from "../../../../_src_shared/utils/agGrid/columnTypes/columnTypesDate";
import { columnTypesNumber } from "../../../../_src_shared/utils/agGrid/columnTypes/columnTypesNumber";
import { columnTypesDollar } from "../../../../_src_shared/utils/agGrid/columnTypes/columnTypesDollar";
import AgGridTableWrapper from "../../../../components/agGrid/AgGridTableWrapper";
import { AgGridReact } from "ag-grid-react";
import Flx from "../../../../components/layout/Flx";

const BorrowerSidepanelTable = ({
  gridRef,
  rowData,
  onRowClicked,
  loading,
  columnDefs,
  onCellClicked,
  onGridReady,
  defaultColDef,
  toggleFavorite,
  isFavorite,
  showEditIcon = true,
}) => {
  const [showGrandTotal, setShowGrandTotal] = useState(false);
  const [quickFilter, setQuickFilter] = useState("");

  const onColumnRowGroupChanged = useCallback((params) => {
    const hasGroups = params.api.getRowGroupColumns().length > 0;
    setShowGrandTotal(hasGroups);
  }, []);

  const getRowId = useCallback((params) => params.data._id, []);
  const getRowStyle = useCallback((params) => {
    if (params.node.footer) {
      return { fontWeight: "bold" };
    }
    return null;
  }, []);
  const _defaultColDef = useMemo(
    () => ({
      cursor: "pointer",
      enableRowGroup: true,
      enablePivot: true,
      enableValue: true,
      showRowGroup: false,
      sortable: true,
      flex: 1,
      resizable: true,
      cellClass: "ag-cell-vertical-center",
      minWidth: 120,
      ...defaultColDef,
    }),
    [defaultColDef],
  );

  const _columnDefs = useMemo(() => {
    if (showEditIcon) {
      return [
        ...columnDefs,
        {
          width: 40,
          minWidth: 40,
          pinned: "right",
          flex: 0,
          cellStyle: { padding: 0 },

          cellRenderer: (p) => {
            return (
              <Flx
                fw
                ac
                // g={1}
                center
                sx={{
                  // justifyContent: "space-evenly",
                  height: "100%",
                  position: "absolute",
                  top: 0,
                  left: 0,
                  pr: 0,
                  // paddingLeft: "18px",
                  // paddingRight: "12px",
                  // px: 1,
                  flexGrow: 1,
                }}
              >
                <EditOutlined className="thin" />
              </Flx>
            );
          },
        },
      ];
    }
    return [...columnDefs];
  }, [showEditIcon, columnDefs]);

  const handleOnRowClicked = useCallback(
    (params) => {
      if (params.node.group) {
        params.node.setExpanded(!params.node.expanded);
        return;
      }
      onRowClicked?.(params?.data);
    },
    [onRowClicked],
  );

  const columnTypes = useMemo(
    () => ({
      ...columnTypesDate(),
      ...columnTypesNumber(),
      ...columnTypesDollar(),
    }),
    [],
  );

  return (
    <AgGridTableWrapper compactTable>
      <AgGridReact
        ref={gridRef}
        rowData={rowData}
        columnDefs={_columnDefs}
        columnTypes={columnTypes}
        getRowId={getRowId}
        quickFilterText={quickFilter}
        defaultColDef={_defaultColDef}
        getRowStyle={getRowStyle}
        grandTotalRow={showGrandTotal ? "bottom" : undefined}
        onColumnRowGroupChanged={onColumnRowGroupChanged}
        onCellClicked={onCellClicked}
        loading={loading}
        domLayout="autoHeight"
        groupDisplayType={"singleColumn"}
        onRowClicked={handleOnRowClicked}
        onGridReady={onGridReady}
        tooltipShowDelay={100}
        headerHeight={54}
        floatingFiltersHeight={40}
        enableCellTextSelection
      />
    </AgGridTableWrapper>
  );
};

export default BorrowerSidepanelTable;
